import React, { ErrorInfo } from "react";
import { Alert } from "reactstrap";
import { doLogError } from "../app/routes/admin/restQueries";
interface IState {
  hasError: boolean;
}

class LocalErrorBoundary extends React.Component<{ id?: string }, IState> {
  constructor(props: {}) {
    super(props);

    this.state = {
      hasError: false,
    };
  }

  errorHappend = async (error: Error, componentStack: string) => {
    if (error?.message?.startsWith("ResizeObserver loop completed with undelivered notifications")) {
      // Ignore ResizeObserver loop errors
      return;
    }

    await doLogError(error.message, `${componentStack}\n\n${error.stack}`, window.location.href);
  };

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.log(`### error boundary ${this.props.id}`);
    this.setState({
      hasError: true,
    });

    this.errorHappend(error, `${info.componentStack}`);
  }

  render() {
    return this.state.hasError === true ? (
      <Alert color="danger" style={{ fontSize: "0.8em" }}>
        <div>
          <b>Det oppstod en uventet feil!</b>
        </div>
        <div>Utviklingsteamet er kontaktet.</div>{" "}
      </Alert>
    ) : (
      this.props.children
    );
  }
}

export default LocalErrorBoundary;
